export default "__VITE_ASSET__45cb84d6__"